import React from 'react';
import { useParams } from 'react-router-dom';

import { useNavigation } from '@refinedev/core';

import {
  Button,
  Checkbox,
  Loading,
  useSnackbar,
} from '@rrexpress/core';

import { BaseShow } from '@/components/show';
import { DataDisplay } from '@/components/show/data-display';
import useLayout from '@/hooks/useLayout';
import { useModal } from '@/hooks/useModal';
import useContact from '@/modules/contact/application/contact';
import { IContact } from '@/modules/contact/model/contact';

const ContactDetail = () => {
  useLayout({ title: 'Kontak' });
  const { id } = useParams<{ id: string }>();

  const { list } = useNavigation();
  const modal = useModal();
  const { show } = useSnackbar();

  const { getContactById, deleteContact, loadingDelete } = useContact();
  const { data, isLoading } = getContactById(id as string);
  const contact: IContact = (data?.data || {}) as IContact;

  async function handleOnDelete(
    idArg: string,
    rowVersion: string,
  ) {
    try {
      await deleteContact(idArg, rowVersion);
      show('Berhasil menghapus kontak', 'success');
      modal.close();
      list('contacts');
    } catch (error) {
      show('Gagal menghapus kontak', 'success');
    }
  }

  function handleOnDeleteShow() {
    modal.open({
      title: 'Hapus Kontak',
      template: loadingDelete
        ? (
          <Loading
            variant="circular"
            size={40}
            speed={0.6}
            indicatorCap="round"
          />
        )
        : (
          <p className="text-[#222222]">
            Apakah anda yakin akan menghapus <span className="font-medium">{contact.contact_name}</span> dari daftar kontak?
          </p>
        ),
      footer: (
        <div className="flex gap-3">
          <Button variant="text" onClick={() => modal.close()}>Batal</Button>
          <Button backgroundColor="#BE321E" onClick={() => handleOnDelete(contact.contact_id ?? '', contact.row_version ?? '')}>
            Hapus
          </Button>
        </div>
      ),
    });
  }

  return (
    <div className="w-[50vw] m-auto">
      <BaseShow
        title={contact.contact_name}
        isLoading={isLoading}
        resource="contacts"
        id={id as string}
        onDelete={handleOnDeleteShow}
      >
        <div className="mb-4">
          <div className="flex flex-col gap-y-3 mb-8">
            <DataDisplay label="Nama Kontak" value={contact.contact_name} />
            <DataDisplay label="No. Telp" value={contact.phone_number} />
            <DataDisplay label="Email" value={contact.email} />
            <DataDisplay label="Alamat" value={contact.address_street || '-'} />
            <DataDisplay label="Kota/Kecamatan" value={`${contact.address_subdistrict_name || ''}, ${contact.address_city_name || ''}, ${contact.address_country_name || ''}`} />
            <DataDisplay label="Kelurahan/Kode Pos" value={`${contact.address_village_name || '-'} / ${contact.address_zipcode}`} />
            <Checkbox label="Aktif" checked={contact.is_active || false} />
          </div>
        </div>
      </BaseShow>
    </div>
  );
};

export default ContactDetail;
